import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useNavigate, useParams } from "react-router-dom";

const cities = [
  'Casablanca', 'Rabat', 'Meknes', 'Marrakech', 'Essaouira', 'Fes',
  'Tanger', 'Agadir', 'Al Hoceima', 'Chefchaouen', 'Nador', 'Kenitra',
  'Assilah', 'Tetouan', 'Ifrane', 'Dakhla'
];

const getYouTubeVideoId = (url) => {
  const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|shorts\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

const UpdatePlan = () => {
  const { id } = useParams();
  const [info, setInfo] = useState({
    city: "", title: "", youtubeUrl: "",
    description: "", order: "", featured: false,
  });
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saved, setSaved] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`https://api.moroccool.com/api/plans/${id}`)
      .then((res) => res.json())
      .then((data) => { setInfo(data); setLoading(false); })
      .catch((err) => { setError("Failed to load plan data"); setLoading(false); });
  }, [id]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setInfo((prev) => ({ ...prev, [id]: value }));
  };

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setInfo((prev) => ({
      ...prev,
      [name]: value === "true" ? true : value === "false" ? false : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch(`https://api.moroccool.com/api/plans/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(info),
      });
      setSaved(true);
      setTimeout(() => navigate("/plans"), 900);
    } catch (err) {
      setError("Failed to update plan");
    }
  };

  const videoId = getYouTubeVideoId(info.youtubeUrl);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,300&family=DM+Mono:wght@400;500&display=swap');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .up-layout {
          display: flex;
          min-height: 100vh;
          background: #FAFAFA;
          font-family: 'DM Sans', sans-serif;
        }

        .up-main {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }

        .up-content {
          flex: 1;
          padding: 40px 48px 60px;
          overflow-y: auto;
          max-width: 1300px;
          width: 100%;
          margin: 0 auto;
        }

        /* ── Header ── */
        .up-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          margin-bottom: 48px;
          padding-bottom: 32px;
          border-bottom: 1px solid #E8E8E8;
        }

        .up-eyebrow {
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          font-weight: 500;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #7C3AED;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .up-eyebrow::before {
          content: '';
          display: inline-block;
          width: 20px;
          height: 1px;
          background: #7C3AED;
        }

        .up-title {
          font-size: 36px;
          font-weight: 600;
          color: #0A0A0A;
          letter-spacing: -0.03em;
          line-height: 1.1;
          margin-top: 6px;
        }

        .up-subtitle {
          font-size: 14px;
          color: #888;
          font-weight: 400;
          margin-top: 6px;
          letter-spacing: -0.01em;
        }

        /* ── Grid ── */
        .up-grid {
          display: grid;
          grid-template-columns: 1fr 360px;
          gap: 24px;
          align-items: start;
        }

        /* ── Card ── */
        .up-card {
          background: #FFFFFF;
          border: 1px solid #EBEBEB;
          border-radius: 16px;
          padding: 36px;
        }

        .up-card-label {
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: #AAAAAA;
          margin-bottom: 28px;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .up-card-label::after {
          content: '';
          flex: 1;
          height: 1px;
          background: #F0F0F0;
        }

        /* ── Form ── */
        .up-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 16px;
        }

        .up-row.full { grid-template-columns: 1fr; }

        .up-field {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .up-field label {
          font-size: 12px;
          font-weight: 500;
          color: #555;
          letter-spacing: 0.01em;
        }

        .up-input,
        .up-select,
        .up-textarea {
          width: 100%;
          background: #FAFAFA;
          border: 1px solid #E8E8E8;
          border-radius: 10px;
          padding: 11px 14px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          color: #0A0A0A;
          outline: none;
          transition: border-color 0.15s, background 0.15s, box-shadow 0.15s;
          -webkit-appearance: none;
          appearance: none;
        }

        .up-input::placeholder,
        .up-textarea::placeholder { color: #C0C0C0; }

        .up-input:focus,
        .up-select:focus,
        .up-textarea:focus {
          border-color: #7C3AED;
          background: #FFFFFF;
          box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.08);
        }

        .up-select {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 14px center;
          padding-right: 36px;
          cursor: pointer;
        }

        .up-textarea {
          resize: vertical;
          min-height: 140px;
          line-height: 1.6;
        }

        /* ── Submit row ── */
        .up-submit-row {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 28px;
          padding-top: 28px;
          border-top: 1px solid #F0F0F0;
        }

        .up-btn-primary {
          background: #7C3AED;
          color: white;
          border: none;
          border-radius: 10px;
          padding: 12px 28px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: -0.01em;
          cursor: pointer;
          transition: background 0.15s, transform 0.1s, box-shadow 0.15s;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .up-btn-primary:hover {
          background: #6D28D9;
          box-shadow: 0 4px 16px rgba(124, 58, 237, 0.28);
          transform: translateY(-1px);
        }

        .up-btn-primary:active { transform: translateY(0); box-shadow: none; }

        .up-btn-primary.saved {
          background: #059669;
          box-shadow: none;
          transform: none;
          cursor: default;
        }

        .up-btn-secondary {
          background: transparent;
          color: #888;
          border: 1px solid #E8E8E8;
          border-radius: 10px;
          padding: 12px 20px;
          font-family: 'DM Sans', sans-serif;
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
          transition: border-color 0.15s, color 0.15s;
          letter-spacing: -0.01em;
        }

        .up-btn-secondary:hover { border-color: #AAAAAA; color: #333; }

        .up-btn-arrow {
          font-size: 16px;
          line-height: 1;
          transition: transform 0.15s;
        }

        .up-btn-primary:hover .up-btn-arrow { transform: translateX(2px); }

        /* ── Error / notice ── */
        .up-error {
          background: #FEF2F2;
          border: 1px solid #FECACA;
          border-radius: 10px;
          padding: 12px 16px;
          font-size: 13px;
          color: #DC2626;
          margin-bottom: 24px;
          font-family: 'DM Sans', sans-serif;
        }

        /* ── Loading state ── */
        .up-loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 60vh;
          gap: 16px;
          color: #AAAAAA;
          font-family: 'DM Sans', sans-serif;
        }

        .up-spinner {
          width: 36px;
          height: 36px;
          border: 2px solid #F0F0F0;
          border-top-color: #7C3AED;
          border-radius: 50%;
          animation: up-spin 0.7s linear infinite;
        }

        @keyframes up-spin { to { transform: rotate(360deg); } }

        .up-loading-text {
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #BBBBBB;
        }

        /* ── Preview ── */
        .up-preview-card {
          background: #FFFFFF;
          border: 1px solid #EBEBEB;
          border-radius: 16px;
          overflow: hidden;
          position: sticky;
          top: 24px;
        }

        .up-video-wrapper {
          width: 100%;
          aspect-ratio: 16/9;
          background: #F5F5F5;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .up-video-wrapper iframe {
          width: 100%;
          height: 100%;
          border: none;
          display: block;
        }

        .up-video-placeholder {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          color: #C8C8C8;
        }

        .up-video-placeholder-icon {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: #EDEDED;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .up-video-placeholder span {
          font-size: 12px;
          font-family: 'DM Mono', monospace;
          letter-spacing: 0.08em;
          text-transform: uppercase;
        }

        .up-preview-body { padding: 24px; }

        .up-preview-city {
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #7C3AED;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .up-preview-title {
          font-size: 18px;
          font-weight: 600;
          color: #0A0A0A;
          letter-spacing: -0.02em;
          line-height: 1.25;
          margin-bottom: 10px;
          min-height: 22px;
        }

        .up-preview-desc {
          font-size: 13px;
          color: #888;
          line-height: 1.65;
          min-height: 40px;
        }

        .up-preview-meta {
          display: flex;
          gap: 8px;
          margin-top: 16px;
          padding-top: 16px;
          border-top: 1px solid #F0F0F0;
          flex-wrap: wrap;
        }

        .up-tag {
          font-family: 'DM Mono', monospace;
          font-size: 10px;
          font-weight: 500;
          letter-spacing: 0.08em;
          padding: 4px 10px;
          border-radius: 100px;
          text-transform: uppercase;
        }

        .up-tag-purple { background: rgba(124, 58, 237, 0.08); color: #7C3AED; }
        .up-tag-amber { background: rgba(217, 119, 6, 0.08); color: #D97706; }
        .up-tag-gray { background: #F5F5F5; color: #888; }

        /* ── ID badge ── */
        .up-id-badge {
          font-family: 'DM Mono', monospace;
          font-size: 11px;
          color: #BBBBBB;
          letter-spacing: 0.06em;
          background: #F8F8F8;
          border: 1px solid #EEEEEE;
          border-radius: 6px;
          padding: 4px 10px;
          align-self: flex-start;
          margin-top: 8px;
        }

        @media (max-width: 900px) {
          .up-grid { grid-template-columns: 1fr; }
          .up-preview-card { position: static; }
          .up-content { padding: 24px 20px 40px; }
          .up-title { font-size: 28px; }
        }
      `}</style>

      <div className="up-layout">
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

        <div className="up-main">
          <Navbar />

          <div className="up-content">

            {loading ? (
              <div className="up-loading">
                <div className="up-spinner" />
                <span className="up-loading-text">Loading plan…</span>
              </div>
            ) : (
              <>
                {/* Header */}
                <div className="up-header">
                  <div>
                    <div className="up-eyebrow">Edit Entry</div>
                    <h1 className="up-title">Update Plan</h1>
                    <p className="up-subtitle">Modify your existing travel plan video</p>
                    <div className="up-id-badge">Plan id: {id}</div>
                  </div>
                </div>

                {error && <div className="up-error">{error}</div>}

                {/* Grid */}
                <div className="up-grid">

                  {/* Form */}
                  <div className="up-card">
                    <div className="up-card-label">Plan Details</div>

                    <form onSubmit={handleSubmit}>
                      <div className="up-row">
                        <div className="up-field">
                          <label>City</label>
                          <select
                            className="up-select"
                            name="city"
                            value={info.city}
                            onChange={handleSelectChange}
                            required
                          >
                            <option value="" disabled>Select a city</option>
                            {cities.map((c) => (
                              <option key={c} value={c}>{c}</option>
                            ))}
                          </select>
                        </div>

                        <div className="up-field">
                          <label>Plan Title</label>
                          <input
                            className="up-input"
                            id="title"
                            type="text"
                            placeholder="Enter an engaging title"
                            value={info.title}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="up-row full" style={{ marginBottom: 16 }}>
                        <div className="up-field">
                          <label>YouTube URL</label>
                          <input
                            className="up-input"
                            id="youtubeUrl"
                            type="text"
                            placeholder="https://www.youtube.com/watch?v=..."
                            value={info.youtubeUrl}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="up-row full" style={{ marginBottom: 16 }}>
                        <div className="up-field">
                          <label>Description</label>
                          <textarea
                            className="up-textarea"
                            id="description"
                            placeholder="Write a compelling description for this travel plan..."
                            value={info.description}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="up-row">
                        <div className="up-field">
                          <label>Display Order</label>
                          <input
                            className="up-input"
                            id="order"
                            type="number"
                            placeholder="1"
                            min={1}
                            value={info.order}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="up-field">
                          <label>Featured</label>
                          <select
                            className="up-select"
                            name="featured"
                            value={info.featured.toString()}
                            onChange={handleSelectChange}
                            required
                          >
                            <option value="false">No</option>
                            <option value="true">Yes — Featured</option>
                          </select>
                        </div>
                      </div>

                      <div className="up-submit-row">
                        <button
                          type="submit"
                          className={`up-btn-primary${saved ? ' saved' : ''}`}
                          disabled={saved}
                        >
                          {saved ? (
                            <>
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                              Saved
                            </>
                          ) : (
                            <>
                              Save Changes
                              <span className="up-btn-arrow">→</span>
                            </>
                          )}
                        </button>
                        <button
                          type="button"
                          className="up-btn-secondary"
                          onClick={() => navigate("/plans")}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>

                  {/* Preview */}
                  <div className="up-preview-card">
                    <div className="up-video-wrapper">
                      {videoId ? (
                        <iframe
                          src={`https://www.youtube.com/embed/${videoId}`}
                          title="YouTube video preview"
                          allowFullScreen
                        />
                      ) : (
                        <div className="up-video-placeholder">
                          <div className="up-video-placeholder-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#AAAAAA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                              <polygon points="5 3 19 12 5 21 5 3" />
                            </svg>
                          </div>
                          <span>Preview</span>
                        </div>
                      )}
                    </div>

                    <div className="up-preview-body">
                      {info.city && (
                        <div className="up-preview-city">
                          <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                          </svg>
                          {info.city}
                        </div>
                      )}

                      <div className="up-preview-title">
                        {info.title || <span style={{ color: '#D0D0D0', fontWeight: 400 }}>Plan title</span>}
                      </div>

                      <div className="up-preview-desc">
                        {info.description || <span style={{ color: '#D8D8D8' }}>Description will appear here...</span>}
                      </div>

                      {(info.featured || info.order) && (
                        <div className="up-preview-meta">
                          {info.featured && <span className="up-tag up-tag-amber">Featured</span>}
                          {info.order && <span className="up-tag up-tag-gray">#{info.order}</span>}
                        </div>
                      )}
                    </div>
                  </div>

                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdatePlan;